module.exports = __webpack_public_path__ + "static/media/biuro3.00b71f16.jpg";